exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a[data-v-4ef5bc02],.b[data-v-4ef5bc02]{fill:#60b661}.a[data-v-4ef5bc02]{opacity:.4}.title[data-v-4ef5bc02]{font-family:Roboto Slab;font-weight:500;font-size:22px;line-height:29px;color:#60b661;margin-top:20px;margin-bottom:45px}.description[data-v-4ef5bc02]{font-family:Rubik;font-weight:300;font-size:16px;line-height:19px;color:#6d6e71;margin-bottom:45px}.btn-teacher-form[data-v-4ef5bc02]{width:100%;max-width:300px;margin:0 auto;display:block;padding:.75rem;border:2px solid #fd8204;color:#fd8204;font-size:20px;font-weight:500;background-color:#fff;border-radius:10px;-webkit-transition:all .2s ease;transition:all .2s ease}.btn-teacher-form[data-v-4ef5bc02]:disabled{background-color:#eeeeef}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ef5bc02","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/TeachersForm/Forms/success.vue
// module id = 369
// module chunks = 0